module.exports = __webpack_public_path__ + "static/img/case-dy-page-bg-01.a55fd53.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/case/dy/case-dy-page-bg-01.jpg
// module id = Zqw9
// module chunks = 1